import { render, staticRenderFns } from "./LegalSection.vue?vue&type=template&id=29a83d67&"
import script from "./LegalSection.vue?vue&type=script&lang=js&"
export * from "./LegalSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29a83d67')) {
      api.createRecord('29a83d67', component.options)
    } else {
      api.reload('29a83d67', component.options)
    }
    module.hot.accept("./LegalSection.vue?vue&type=template&id=29a83d67&", function () {
      api.rerender('29a83d67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/sections/LegalSection.vue"
export default component.exports